import { Badge, Card } from "@procurement-agents/ui";
import { displayEndIdsIn, type RunState } from "@procurement-agents/scope-api";

export function PlanReader({ state }: { state: RunState }) {
  const plan = state.section_plan;
  const included = plan.filter((p) => p.include).length;
  const entries = new Map((state.run_plan?.entries ?? []).map((e) => [e.id, e]));
  const title = (id: string) => state.sow[id]?.title ?? entries.get(id)?.title ?? id;
  const template = state.run_plan?.template_name;
  return (
    <Card title="Section plan" aside={<span className="muted small">{included} of {plan.length} sections</span>}>
      {template && <p className="muted small">From the {template} template{state.run_plan?.template_version ? `, version ${state.run_plan.template_version}` : ""}.</p>}
      <ol className="plan readonly">
        {plan.map((p) => {
          const e = entries.get(p.section_id);   // CHANGE_plan_control: lifted and merged sections say so
          return (
            <li key={p.section_id} className={p.include ? "" : "excluded"}>
              <div className="row">
                <strong>{title(p.section_id)}</strong>
                {e?.lifted_reason ? <Badge tone="warn">required, left out by procurement</Badge>
                  : e?.merged_into ? <Badge>merged</Badge>
                  : !p.include && <Badge>left out</Badge>}
                {!!e?.merged_from?.length && <Badge tone="info">merged</Badge>}
              </div>
              <p className="muted small">{displayEndIdsIn(p.reason)}{p.focus ? ` Focus: ${p.focus}` : ""}</p>
            </li>
          );
        })}
      </ol>
    </Card>
  );
}
